
import { useEffect, useState, useRef, useCallback } from 'react'
import breadcrumbPathsUtils from '../breadcrumbPaths.utils'

const useBreadcrumbs = (paths: string[], isToggleButtonEnabled: boolean) => {

  const containerRef = useRef<HTMLDivElement>(null) // Ссылаемся на DOM-элемент контейнера для вычисления его ширины
  const [visiblePaths, setVisiblePaths] = useState<string[]>(paths) // Массив путей, которые отображаются, если ширины не хватает
  const [showAll, setShowAll] = useState(false)

  // Функция для обновления видимых путей на основе ширины контейнера
  const updateVisiblePaths = useCallback(() => {
    const containerWidth = containerRef.current?.offsetWidth || 0 // Получаем текущую ширину контейнера
    if (containerWidth === 0) return
    setVisiblePaths(breadcrumbPathsUtils.calculateVisiblePaths(paths, containerWidth))  // Вызываем утилиту для вычисления видимых путей с учетом ширины контейнера
  }, [paths])

  useEffect(() => {
    updateVisiblePaths()

    // Создаем и наблюдаем за изменениями размеров контейнера
    const resizeObserver = new ResizeObserver(updateVisiblePaths)
    resizeObserver.observe(containerRef.current)

    return () => resizeObserver.disconnect()
  }, [updateVisiblePaths])

  const shouldShowToggleButton = visiblePaths[0] !== paths[0] && isToggleButtonEnabled // Логика для отображения кнопки "Показать все" (если не все пути видны)

  return {
    containerRef,
    visiblePaths,
    showAll,
    setShowAll,
    shouldShowToggleButton,
    updateVisiblePaths,
  }
}

export default useBreadcrumbs
